<template>
	<div class="rich-media">

		<div class="page-header">
			<h1 class="page-title">Rich Media</h1>
		</div>

		<div class="banners">
			<div class="banner" v-for="(item, index) in rich_media" :key="index">
				<h4>{{ item.name }}</h4>
				<p v-if="item.description">{{ item.description }}</p>
				<div class="banner-content" v-html="item.tag"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "RichMedia",
	props: ["rich_media"],
	mounted() {
		if (typeof window.Somplo !== 'function') {
			const script = document.createElement('script');
			script.src = "https://cdn.somplo.com/prod/tags/080624/tag.min.js";
			script.async = true;
			document.head.appendChild(script);
		}
	}
};
</script>